import React from "react";
import ReactDOM from "react-dom/client";
import "bootstrap/dist/css/bootstrap.css";
import "./index.css";
import App from "./App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import reportWebVitals from "./reportWebVitals";
import axios from "axios";
import { toast } from "react-toastify";
import {
    getAuthToken,
    logoutOnExpiredSession,
    shouldLogoutOnUnauthorized,
} from "./Components/authSession";

if (typeof window !== "undefined" && "scrollRestoration" in window.history) {
    window.history.scrollRestoration = "manual";
}

axios.defaults.timeout = Number(process.env.REACT_APP_API_TIMEOUT_MS) || 60000;
axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

const shouldRetryRequest = (error) => {
    const method = (error?.config?.method || "get").toLowerCase();
    if (!["get", "head", "options"].includes(method)) {
        return false;
    }
    if (error?.response?.status && error.response.status < 500) {
        return false;
    }
    return (
        error?.code === "ECONNABORTED" ||
        !error?.response ||
        error.response.status >= 500
    );
};

axios.interceptors.request.use((request) => {
    const token = getAuthToken();

    if (token) {
        request.headers.Authorization = "Bearer " + token;
    } else {
        delete request.headers.Authorization;
    }

    request.headers.Accept = "application/json";
    return request;
});

axios.interceptors.response.use(
    (response) => response,
    async (error) => {
        const config = error?.config;
        if (config && shouldRetryRequest(error)) {
            config.__retryCount = config.__retryCount || 0;
            if (config.__retryCount < 2) {
                config.__retryCount += 1;
                await new Promise((resolve) =>
                    setTimeout(resolve, 400 * config.__retryCount)
                );
                return axios(config);
            }
        }

        if (shouldLogoutOnUnauthorized(error)) {
            toast.error("نشست شما منقضی شده است. لطفاً دوباره وارد شوید.", {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            logoutOnExpiredSession();
            return Promise.reject(error);
        }

        return Promise.reject(error);
    }
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);

serviceWorkerRegistration.unregister();

if (typeof window !== "undefined" && "caches" in window) {
  caches.keys().then((names) =>
    Promise.all(names.map((name) => caches.delete(name)))
  );
}

try {
  const legacySessionKeys = [];
  for (let i = 0; i < sessionStorage.length; i += 1) {
    const key = sessionStorage.key(i);
    if (
      key?.startsWith("visitor-order-list:") ||
      key === "visitor_profile_cache"
    ) {
      legacySessionKeys.push(key);
    }
  }
  legacySessionKeys.forEach((key) => sessionStorage.removeItem(key));
  localStorage.removeItem("vizit_shop_reference_cache_v1");
  localStorage.removeItem("visitor_permissions");
} catch (_) {
  // ignore storage cleanup errors
}

reportWebVitals();
